import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ManualMatchDialogComponent } from "./manual-match-dialog.component";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzButtonModule } from "ng-zorro-antd/button";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzSelectModule } from "ng-zorro-antd/select";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [ManualMatchDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NzModalModule,
    NzButtonModule,
    FormsModule,
    NzFormModule,
    NzGridModule,
    NzSelectModule,
    ReactiveFormsModule,
  ],
  exports: [ManualMatchDialogComponent],
})
export class ManualMatchDialogModule {}
